var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_vm._v(" Copyright ©2025 深圳市赛鹏标准信息服务有限公司 版权所有 "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.click}},[_vm._v("备案号：粤ICP备2025398064号-1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }